import { useEffect, useState } from 'react';

const MAX_SECONDS = 60 * 10;

const useTimerHook = () => {
	const [timer, setTimer] = useState(MAX_SECONDS);

	useEffect(() => {
		const interval = setInterval(() => {
			setTimer((prev) => Math.max(0, prev - 1));
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	const formatTime = (currentTime) => {
		const minutes = Math.floor(currentTime / 60);
		const seconds = currentTime % 60;

		return `${minutes < 10 ? '0' + minutes : minutes}:${
			seconds < 10 ? '0' + seconds : seconds
		}`;
	};

	return formatTime(timer);
};

export default useTimerHook;
